import { readSession, writeSession } from '../state/storage';
import type { InterruptId } from './types';

const DISMISSED_INTERRUPTS_KEY = 'dismissed-interrupts';

export function getDismissedInterruptIds(): InterruptId[] {
  return readSession<InterruptId[]>(DISMISSED_INTERRUPTS_KEY) ?? [];
}

export function dismissInterrupt(id: InterruptId): void {
  const current = getDismissedInterruptIds();
  if (current.includes(id)) return;
  writeSession(DISMISSED_INTERRUPTS_KEY, [...current, id]);
}
